import styled from 'styled-components';

export const ColumnLabelWithTooltip = styled.div`
  display: flex;
  align-items: center;
  column-gap: 8px;
`;

export const TooltipIcon = styled.img`
  width: 16px;
  height: 16px;

  display: block;
`;
